import React, { createContext, useContext, ReactNode } from 'react';

import { useOptionsList } from '@hooks/useOptionsList';

interface OptionsDataContextValue {
  options: ReturnType<typeof useOptionsList>;
}

const OptionsDataContext = createContext<OptionsDataContextValue | undefined>(
  undefined,
);

export function OptionsDataProvider({ children }: { children: ReactNode }) {
  const optionsData = useOptionsList({
    timeframe: 'all',
    sortDirection: 'desc',
    assetFilter: 'ALL',
  });

  return (
    <OptionsDataContext.Provider value={{ options: optionsData }}>
      {children}
    </OptionsDataContext.Provider>
  );
}

export function useOptionsData() {
  const context = useContext(OptionsDataContext);
  if (!context) {
    throw new Error('useOptionsData must be used within OptionsDataProvider');
  }
  return context.options;
}

